import * as behaviors from './behaviors'
import * as subjects from './subjects'
import * as trees from './trees'

const providerMap = {
	behaviors, subjects, trees,
}

export default providerMap
